export const UPDATE_DATA = 'UPDATE_DATA';
export const UPDATE_SEARCH = 'UPDATE_SEARCH';
export const UPDATE_SORT = 'UPDATE_SORT';
export const UPDATE_FILTER = 'UPDATE_FILTER';
export const UPDATE_ERROR_FILTER = 'UPDATE_ERROR_FILTER';
export const UPDATE_ERROR_MESSAGE = 'UPDATE_ERROR_MESSAGE';
export const UPDATE_SCROLL_TO_INDEX = 'UPDATE_SCROLL_TO_INDEX';
export const SELECT_REQUEST = 'SELECT_REQUEST';
export const FETCH_FILE = {
  REQUEST: 'FETCH_FILE_REQUEST',
  SUCCESS: 'FETCH_FILE_SUCCESS',
  FAILURE: 'FETCH_FILE_FAILURE',
};
export const RESET = 'RESET';
